import type { CampaignTypeKey } from 'entities/campaign';

import { isImpersonate } from './api';

export type DataLayerEventName = 'confirm_budget' | 'edit_budget';
type CampaignTypeValue = 1 | 2 | 3;

export interface DataLayerObject {
  event: DataLayerEventName;
  contractorId?: number;
  contractorEmail?: string;
  visitorType?: 'contractor' | 'impersonation';
  campaignId?: number;
  campaignName?: string;
  campaignType?: CampaignTypeValue;
  oldBudget?: number | string;
  newBudget?: number | string;
}

export const pushToDataLayer = (obj: DataLayerObject) => {
  window.dataLayer = window.dataLayer ?? [];
  window.dataLayer.push(obj);
};

type GetBudgetChangeMetricsDataType = Omit<BudgetChangeMetricsDataObject, 'visitorType' | 'campaignType'> & {
  campaignType: CampaignTypeKey;
};

interface BudgetChangeMetricsDataObject {
  contractorId: number;
  contractorEmail: string;
  visitorType: 'contractor' | 'impersonation';
  campaignId: number;
  campaignName: string;
  campaignType: CampaignTypeValue;
  oldBudget: number | string;
  newBudget: number | string;
}

export const getBudgetChangeMetricsData = ({
  contractorId,
  contractorEmail,
  campaignType,
  campaignId,
  campaignName,
  oldBudget,
  newBudget,
}: GetBudgetChangeMetricsDataType): BudgetChangeMetricsDataObject => {
  const campaignTypeMapper: Record<CampaignTypeKey, 1 | 2 | 3> = {
    lead: 1,
    appt: 2,
    sales: 3,
  };

  return {
    contractorId,
    contractorEmail,
    visitorType: isImpersonate() ? 'impersonation' : 'contractor',
    campaignId,
    campaignName,
    campaignType: campaignTypeMapper[campaignType],
    oldBudget: Number(oldBudget),
    newBudget: Number(newBudget) * 100,
  };
};
